import { Box, Button, Link, Tooltip, Typography } from "@mui/material";
import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from "react";
import { GetAllTracker, GetAllTrackerTrim } from "../../services/Item/ItemServicesGet";
import { trackerItemVO } from "../../model/ItemModel";
import { NotFoundUpdateIcon } from "../../assets/icons/NotFoundUpdates";
import { useTranslation } from "react-i18next";
import LoaderComp from "../../components/Loader/LoaderComp";
import FolderIcon from '@mui/icons-material/Folder';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SaveAltSharpIcon from '@mui/icons-material/SaveAltSharp';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Pendencie } from "../../assets/icons/pendencie";
import { useNavigate } from "react-router-dom";
import { NoUpdatesIcon } from "../../assets/icons/noUpdates";
import styles from './FeedDataList.module.css';
import { formatDateNow } from "../../functions/formatedDates";
import { Delete } from "@mui/icons-material";
import { EmptyContainer } from "../../components/KeydriveComponents/EmptyContainer/EmptyContainer";

interface IFeedDataList {
    nameOrg: string;
    begin: string;
    end: string;
    showAll: boolean;
    applyFilter: boolean;
    setApplyFilter: Dispatch<SetStateAction<boolean>>;
    setShowAll: Dispatch<SetStateAction<boolean>>;
    setIsReseting: Dispatch<SetStateAction<boolean>>;
    selectedUserId?: string;
    isReseting: boolean;
}

export const FeedDataList: React.FC<IFeedDataList> = ({ isReseting, setIsReseting, nameOrg, begin, end, showAll, applyFilter, setApplyFilter, selectedUserId, setShowAll }) => {

    const [feed, setFeed] = useState <trackerItemVO[]>([]);
    const [noContent, setNoContent] = useState<boolean>(false);
    const [noContentWithFilter, setNoContentWithFilter] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingMore, setLoadingMore] = useState<boolean>(false);
    const [isCommingBySkip, setIsCommingBySkip] = useState<boolean>(false);
    const [limit] = useState<number>(50);
    const [skip, setSkip] = useState<number>(0);
    const [hasMoreData, setHasMoreData] = useState<boolean>(true); 
    const observerRef = useRef<IntersectionObserver | null>(null);

    const {t} = useTranslation();
    const navigate = useNavigate();

    const dateNow = formatDateNow();

    const displayedTitles = new Set<string>();

    const renderFeedItem = (item: trackerItemVO) => {
        const itemDateTitle = renderItemDateTitle(item.dateCreateTracker!, true);

        const showTitle = !displayedTitles.has(itemDateTitle);
        if (showTitle) displayedTitles.add(itemDateTitle);

        var itemNameFile
        var itemMessageShort

        const palavrasParaDestacar = [
            item.emailUser, 
            item.user, 
            item.nameItem
        ];

        const regex = new RegExp(`(${palavrasParaDestacar.join('|')})`, 'gi');

        if(item.nameItem && item.nameItem.length > 50){
            itemNameFile = item.nameItem?.split(".")[0].slice(0, 50)+"... "+item.nameItem?.split(".")[1];
            itemMessageShort = item.message?.replace(item.nameItem, itemNameFile)
        }

        return (
            <Box className={styles.dateContainer} key={item.id}>
                {showTitle && (
                    <Typography className={styles.dateText}>
                        {itemDateTitle}
                    </Typography>
                )}

                <Box className={styles.feedBoxContainer}>
                    <Box className={styles.iconBox}>
                        {renderItemIcon(item)}
                    </Box>

                    <Box className={styles.feedBoxContent}>
                        <Box>
                            <Typography className={styles.dateAction}>
                                {renderItemDateTitle(item.dateCreateTracker!, false)}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: '4px' }}>
                                
                                <Tooltip title={itemMessageShort??item.message}>
                                    <Typography className={styles.actionTitle}>{
                                    (itemMessageShort??item.message!).split(regex).map((parte, index) =>
                                    palavrasParaDestacar.some(p => p === parte) ? (
                                    <strong key={index}>{parte}</strong>
                                    ) : (
                                    parte
                                    )
                                    )
                                    }</Typography>
                                </Tooltip>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                            <Typography className={styles.dateAction}>IP {item.ip}</Typography>
                            <Box sx={{display: "flex", alignItems: "center"}}>
                                <OpenInNewIcon sx={{ color: '#22638D', height: '16px' }} />
                                <Link className={styles.seeMoreBtn} onClick={() => navigate(`/${nameOrg}/wsallowed/${item.originWorkspace}${item.fatherId ? "/" + item.fatherId : ''}`)}>{t("Feed.SeeMore")}</Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    };

    const renderItemDateTitle = (date: string, title: boolean) => {
        const itemDate = new Date(date);
        const today = new Date();
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);

        const isToday = itemDate.toDateString() === today.toDateString();
        const isYesterday = itemDate.toDateString() === yesterday.toDateString();

        const formatTime = (date: Date) => {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`;
        };

        if (title) {
            if (isToday) {
                return t("Feed.Today");
            } else if (isYesterday) {
                return t("Feed.Yesterday");
            } else {
                return t("Feed.PreviousUpdates");
            }
        } else {
            if (isToday) {
                return `${t("Feed.Today")} ${formatTime(itemDate)}`;
            } else if (isYesterday) {
                return `${t("Feed.Yesterday")} ${formatTime(itemDate)}`;
            } else {
                const day = String(itemDate.getDate()).padStart(2, '0');
                const month = String(itemDate.getMonth() + 1).padStart(2, '0');
                const year = itemDate.getFullYear();
                return `${day}/${month}/${year} ${formatTime(itemDate)}`;
            }
        }
    };

    const renderItemIcon = (item: trackerItemVO) => {
        switch (item.trackerType){
            case 1:
                return <FileUploadOutlinedIcon sx={{ color: '#22638D ' }} />
            case 2:
                return <FileUploadOutlinedIcon sx={{ color: '#22638D ' }} />
            case 3:
                return <SaveAltSharpIcon sx={{ color: '#22638D ' }} />
            case 4:
                return <Pendencie color={"#22638D"} colorCircle={'#22638D'} />
            case 5:
                return <OpenInNewIcon sx={{ color: '#22638D ' }} />
            case 6:
                return <Delete sx={{ color: '#22638D' }} />
            default:
                return <FolderIcon sx={{ color: '#22638D ' }} />
        }
    } 

    const fetchData = () => {
        if (!isCommingBySkip)
            setLoading(true);

        const fetchFunction = GetAllTracker(nameOrg, begin, end, skip, limit, selectedUserId);

        fetchFunction
            .then((data) => {
                if (data.length === 0) {
                    if (applyFilter) {
                        setNoContentWithFilter(true);
                    } else {
                        setNoContent(true);
                    }
                } else {
                    if(data.length < limit){
                        setHasMoreData(false);
                    }
                    setFeed((prevFeed) => skip === 0 ? data : [...prevFeed, ...data]);
                    setNoContent(false);
                    setNoContentWithFilter(false);
                }
            })
            .catch((error) => console.error(error.response.data))
            .finally(() => {
                setLoading(false);
                setLoadingMore(false);
                setApplyFilter(false);
                if (isCommingBySkip) {
                    setIsCommingBySkip(false);
                }
                if (isReseting) {
                    setIsReseting(false);
                }
            });

    }

    const lastItemRef = useCallback((node) => {
        if (observerRef.current) observerRef.current.disconnect();

        observerRef.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsCommingBySkip(true);
                setSkip((prevSkip) => prevSkip + limit);
            }
        });

        if (node) observerRef.current.observe(node);
    }, [loading, limit]);

    useEffect(() => {
        fetchData();
    }, [isReseting])

    useEffect(() => {
        if (applyFilter) {
            setFeed([]);
            setSkip(0);
            setNoContent(false);
            setNoContentWithFilter(false);
            setHasMoreData(true);
            fetchData();
        }
    }, [applyFilter]);

    useEffect(() => {
        fetchData();
    }, [skip]);


    return (

        <>
            { loading ? (
                <LoaderComp big />
            ) : (
                <>
                    { feed?.length <= 0 ? (
                        <Box className={ styles.feedUpdates } >
                            <EmptyContainer 
                                icon={noContentWithFilter ? <NoUpdatesIcon /> : <NotFoundUpdateIcon />}
                                title={noContentWithFilter ? t("Feed.NoContentFound") : t("Feed.NonExistingUpdates")}
                                content={noContentWithFilter ? t("Feed.NoContentWithFilter") : t("Feed.NonExistingUpdatesText")}
                            />
                        </Box >
                    ) : (
                    <>
                        {feed.map((feedItem, index) =>
                                index === feed.length - 1 ? (
                                    <div ref={lastItemRef} key={feedItem.id}>
                                        {renderFeedItem(feedItem)}
                                    </div>
                                ) : (
                                    renderFeedItem(feedItem)
                                )
                            )}

                        </>
                    ) }
                </>
            ) }
        </>
    )
}